import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Import reducers
import auth from "./auth/reducer";
import context from "./context/reducer";
import media from "./media/reducer";
import call from "./call/reducer";
import timer from "./timer/reducer";
import config from "./config/reducer";

// Configure Perist
const authPersistConfig = {
  key: "auth",
  storage,
  blacklist: ["loading", "error"],
};

const mediaPersistConfig = {
  key: "media",
  storage,
  blacklist: ["localMedia"],
};

const setupPersistConfig = {
  key: "setup",
  storage,
  blacklist: ["loading", "error"],
};

// Combine reducers
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, auth),
  media: persistReducer(mediaPersistConfig, media),
  config: persistReducer(setupPersistConfig, config),
  context,
  call,
  timer,
});

// Create reducer
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootStateType = ReturnType<typeof store.getState>;
export type AppDispatchType = typeof store.dispatch;
